/**
 * This is a weird one: we need to have separate tabs for the two (hardcoded'ish) equipment types.
 * Technically these could be classifiers, but then we'd need a mechanism to dynamically choose which columns should be shown in view.
 * Since then we'd need nested classifiers for that, it'd probably overcomplicate everything. Hence, an enum. KISS and YAGNI.
 */
export enum EquipmentType {
  selfPropelledMachinery = 'self_propelled_machinery',
  machinesAndAggregates = 'machines_and_aggregates',
}
